'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _each2 = require('lodash/each');

var _each3 = _interopRequireDefault(_each2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = { each: _each3.default };

var _module = _angular2.default.module('cb.ui-components.tabs.cbTabsController', []);

_module.controller('cbTabsController', cbTabsController);

exports.default = _module;


function cbTabsController() {
    var vm = this;

    vm.registerPane = registerPane;
    vm.setActive = setActive;
    vm.isActive = isActive;

    var tabs = {};

    function registerPane(name) {
        if (typeof tabs[name] !== 'undefined') {
            throw new Error('cb-tabs: Trying to register tab with duplicate name');
        }

        tabs[name] = false;
    }

    function setActive(name) {
        _.each(tabs, function (value, key) {
            tabs[key] = key === name;
        });
    }

    function isActive(name) {
        return tabs[name];
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/tabs/cb-tabs.controller.js
// module id = 918
// module chunks = 0